var _rect, _rect2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: 1,
    width: 16,
    height: 16,
    rx: 8,
    transform: "matrix(-1 0 0 1 16 0)",
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: 1,
    width: 16,
    height: 16,
    rx: 8,
    transform: "matrix(-1 0 0 1 16 0)",
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3599 9.43946L9.59711 11.7532C9.46694 11.924 9.46694 12.201 9.59711 12.3719C9.72728 12.5427 9.93832 12.5427 10.0685 12.3719L12.3806 9.33722C12.4534 9.25697 12.4998 9.13657 12.4998 9.00198L12.4998 9.00052C12.4998 8.93168 12.4875 8.86283 12.4629 8.80014C12.4474 8.76066 12.4271 8.72361 12.4019 8.69054L12.3951 8.68181L10.0685 5.62814C9.93831 5.45729 9.72726 5.45729 9.59709 5.62814C9.46693 5.79898 9.46693 6.07598 9.59709 6.24683L11.3629 8.5645L5.83351 8.5645C5.64943 8.5645 5.5002 8.76037 5.5002 9.00198C5.5002 9.2436 5.64943 9.43946 5.83351 9.43946L11.3599 9.43946Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.82d14032.svg";
export { ForwardRef as ReactComponent };